// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__jdUV4","login_card":"Login_login_card__N9fWZ"};